export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";